import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import {
  createPortInOrder,
  getOrderDetail,
  cleanPayload,
  updatePortInOrder,
} from '../../../actions/Inteliquent';
import { getStateCodes } from '../../../actions/ProposalsEditor';
import { diff } from 'deep-object-diff';
import './CreateOrder.css';
import { toast } from 'react-toastify';
import { useLocation, useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import OrderForm from './OrderForm';
import NumberFormContainer from './NumberFormContainer';
import PortingCNAM from './PortingCNAM';
const VALIDEXT = [
  'docx',
  'txt',
  'xlsx',
  'pdf',
  'log',
  'pcap',
  'zip',
  'jpg',
  'jpeg',
  'ping',
  'gif',
  'pptx',
  'png',
];
export default function CreateOrder() {
  const token = localStorage.getItem('jwtToken') || null;
  const [isCnam, setIsCnam] = useState("no")
  const [cnamData, setCnamData] = useState([])
  const pram = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const searchpram = useLocation().search;
  const { stateCodes } = useSelector(state => state.UIState.proposalEditor);
  const [step, setStep] = useState(() => {
    if (searchpram && new URLSearchParams(searchpram).get('step'))
      return Number(new URLSearchParams(searchpram).get('step'));
    return 1;
  });

  const [extraTnOptions, setExtraTnOptions] = useState(
    (searchpram &&
      new URLSearchParams(searchpram)
        .get('tnOptions')
        ?.split(',')
        .filter(Boolean)) ??
      [],
  );
  const trunkGroup = searchpram && new URLSearchParams(searchpram).get('trunkGroup');
  const [checkedGroups, setCheckedGroups] = useState(
    (searchpram &&
      new URLSearchParams(searchpram)
        .get('groups')
        ?.split(',')
        .filter(Boolean)) ??
      [],
  );

  const [data, setData] = useState({});

  useEffect(() => {
    console.clear();
  }, []);

  useEffect(() => {
    if (pram.id && !Object.keys(data).length) {
      dispatch(getOrderDetail(token, pram.id)).then(({ orderDetailResponse }) => {
        const tnOptions = orderDetailResponse.tnList?.tnItem.reduce((acc, { tn }) => {
          acc.push(`${tn}`);
          return acc;
        }, []);

        setData({
          customerOrderReference: orderDetailResponse.customerOrderReference,
          resellerName: orderDetailResponse?.resellerName,
          desiredDueDate: orderDetailResponse.desiredDueDate?.split('T')[0],
          desiredPortTime: orderDetailResponse.desiredPortTime?.split(' ')[0],
          desiredPortTimeZone: orderDetailResponse.desiredPortTime?.split(' ')[1],
          tnList: {
            tnItem: orderDetailResponse.tnList.tnItem
              .map(num => {
                const location = Object.fromEntries(
                  Object.entries(num.endUser).filter(([key]) => key.includes('location')),
                );

                return {
                  ...num,
                  tn: [num.tn],
                  name: num.endUser?.name,
                  authName: num.authName,
                  accountNum: num.accountNum,
                  accountPin: num.accountPin,
                  atn: num.atn,
                  name: num.endUser?.name,
                  typeOfService: num.endUser?.typeOfService,
                  streetNum: num.endUser?.streetNum,
                  streetNum: num.endUser?.streetNum,
                  streetPreDir: num.endUser?.streetPreDir,
                  streetName: num.endUser?.streetName,
                  streetType: num.endUser?.streetType,
                  streetPostDir: num.endUser?.streetPostDir,
                  city: num.endUser?.city,
                  state: num.endUser?.state,
                  postalCode: num.endUser?.postalCode,
                  locations: objectToLocation(location) ?? [],
                };
              })
              .filter(tn => checkedGroups.includes(tn.tnGroup)),
          },
        });
        setExtraTnOptions(prev => [...prev, ...tnOptions]);
      });
    }
  }, [pram.id]);

  useEffect(() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }), [step]);

  function locationToObject(myloc) {
    return myloc.reduce((acc, { Type, Value }, index) => {
      acc[`locationValue${index + 1}`] = Value;
      acc[`locationType${index + 1}`] = Type;
      return acc;
    }, {});
  }

  function objectToLocation(locationObj) {
    return Object.entries(locationObj).reduce((acc, [key, value]) => {
      key = key.replace('location', '');
      const index = key.slice(-1);
      const type = key.split(index)[0];
      acc[index - 1] = { ...acc[index - 1], [type]: value };
      return acc;
    }, []);
  }

  async function createOrder(values, notes, files) {
    return await dispatch(createPortInOrder(token, { ...values, cnam: cnamData }, notes, files));
  }

  async function updateOrder(values, notes, files) {
    return await dispatch(updatePortInOrder(token, { ...values, cnam: cnamData }, notes, files));
  }
  async function onSubmit(values) {
    const loading = toast.info('Loading', { autoClose: 5000 });
    var emailContactItem = [];
    if (values.contact)
      emailContactItem = values.contact.map(item => {
        return {
          emailContact: item.email,
        };
      });
    let body = {
      portInOrder: cleanPayload({
        customerOrderReference: values.customerOrderReference,
        resellerName: values?.resellerName,
        desiredDueDate: values.desiredDueDate,
        desiredPortTime: values.desiredPortTime,
        desiredPortTimeZone: values.desiredPortTimeZone,
        onDemandActivation: values.onDemandActivation ? 'Y' : 'N',
        tnList: {
          tnItem: values.tnList.tnItem
            .map(
              ({
                locations,
                authName,
                authDate,
                accountNum,
                accountPin,
                atn,
                name,
                typeOfService,
                streetNum,
                streetPreDir,
                streetName,
                streetType,
                streetPostDir,
                city,
                state,
                postalCode,
                tn,
                // trunkGroup,
              }) =>
                tn.map(num =>
                  cleanPayload({
                    tn: num,
                    routingLabel: '',
                    // trunkGroup,
                    trunkGroup,
                    authName,
                    authDate,
                    accountNum,
                    accountPin,
                    atn,
                    tnNote: values.tnNote,
                    endUser: {
                      ...locationToObject(locations),
                      name,
                      streetNum,
                      typeOfService,
                      streetPreDir,
                      streetName,
                      streetType,
                      streetPostDir,
                      city,
                      state,
                      postalCode,
                    },
                  }),
                ),
            )
            .flat(1),
        },
        emailContactList: {
          emailContactItem,
        },
        contactList: [
          {
            contactName: 'epik team',
            contactWorkPhone: '9498928885',
            contactExtn: ' ',
            contactEmail: 'usama@epik.io',
          },
        ],
      }),
    };

    if (pram.id) {
      let payloaddiff;
      // if (step === 1) {
      body = { orderUpdate: { ...body.portInOrder, orderId: pram.id } };
      // }
      // if (step === 2) {
      //   const { tnList: number_prev, ...orderdetails_prev } = data;
      //   const {
      //     tnList: number_new,
      //     ...orderdetails_new
      //   } = body.portInOrder;
      //   payloaddiff = cleanPayload(
      //     diff(orderdetails_prev, orderdetails_new),
      //   );
      //   body = { orderUpdate: { ...payloaddiff, orderId: pram.id } };
      // }
      const isFilesValid = varifyFiles(values.files);
      if (!isFilesValid) {
        toast.dismiss(loading);
        return toast.error(`Please select file with extension ${VALIDEXT.join(', ')}`);
      }
      updateOrder(body, values.tnNote, values.files)
        .then(() => {
          toast.success('Successfully Updated');
          history.push(`/provisioning/porting/order/${pram.id}`);
        })
        .catch(console.error)
        .finally(() => toast.dismiss(loading));
    } else {
      const res = await createOrder(body, values.tnNote, values.files);
      if (res) {
        toast.success('Port number(s) ordered successfully');
        history.push(`/provisioning/porting/order/${res?.orderId}`);
      }
    }
  }
  const varifyFiles = files => {
    for (var i = 0; i < files.length; i++) {
      var ext = String(files[i].file[0].name)
        .split('.')
        .pop()
        .trim();
      if (!VALIDEXT.includes(ext)) {
        return false;
      }
    }
    return true;
  };
  useEffect(() => {
    dispatch(getStateCodes(token));
  }, []);

  if (!stateCodes.length || (pram.id && !Object.keys(data).length))
    return <div className="lead">Loading</div>;
  return (
    <div>
      {step != 2 && <div className="text-right">
        <Button
          type="button"
          className="mr-2"
          onClick={() => history.push('/provisioning/porting')}
        >
          Close
        </Button>
      </div>}

      <div>
        {step === 1 && (
          <NumberFormContainer
            id={pram.id}
            extraTnOptions={extraTnOptions}
            intialValue={data.tnList ?? { tnItem: [{}] }}
            isCnam={isCnam}
            setIsCnam={setIsCnam}
            submit={value => {
              // if (pram.id) {
              //   onSubmit({ tnList: value });
              // } else {
              setData(data => ({ ...data, tnList: value }));
              if (isCnam === "yes") {
                setStep(2);
              } else
                setStep(3);
              // }
            }}
          />
        )}
        {step === 2 && (
          <PortingCNAM
            onStepBack={() => setStep(1)}
            onStepNext={(data) => { console.log(data); setCnamData(data); setStep(3) }}
            numbers={extraTnOptions}
          />
        )}
        {step === 3 && (
          <OrderForm
            submit={values => onSubmit({ ...data, ...values })}
            intialValue={data}
            onBack={() => setStep(1)}
            id={pram.id}
          />
        )}
      </div>
    </div>
  );
}
